import { useQuery } from '@tanstack/react-query';
import { Building2, Users, CheckCircle2, PauseCircle, XCircle, ShieldCheck } from 'lucide-react';
import api from '@/lib/axios';

export function SuperAdminDashboardPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['sa-stats'],
    queryFn: () => api.get('/api/super-admin/stats').then(r => r.data),
    staleTime: 0,           // siempre refetch al montar
    refetchOnWindowFocus: true,
  });

  const porEstado: Record<string, number> = {};
  (data?.clinicasPorEstado ?? []).forEach((r: any) => {
    // El backend retorna { estadoClinica, total }
    const key = r.estadoClinica ?? r.estado;
    porEstado[key] = Number(r.total);
  });

  const cards = [
    { label: 'Clínicas activas',  value: isLoading ? '…' : (data?.totalClinicas ?? 0), icon: Building2,    color: 'text-blue-400' },
    { label: 'Total médicos',     value: isLoading ? '…' : (data?.totalMedicos ?? 0),  icon: Users,        color: 'text-emerald-400' },
    { label: 'Activas',           value: isLoading ? '…' : (porEstado.activa ?? 0),    icon: CheckCircle2, color: 'text-emerald-400' },
    { label: 'Suspendidas',       value: isLoading ? '…' : (porEstado.suspendida ?? 0),icon: PauseCircle,  color: 'text-amber-400' },
    { label: 'Eliminadas',        value: isLoading ? '…' : (porEstado.eliminada ?? 0), icon: XCircle,      color: 'text-red-400' },
  ];

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="flex items-center gap-3">
        <ShieldCheck className="text-amber-400" size={28} />
        <div>
          <h1 className="text-2xl font-bold text-white">Panel Super Admin</h1>
          <p className="text-slate-400 text-sm mt-0.5">Vista global de la plataforma Anik</p>
        </div>
      </div>

      {/* Stat cards */}
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        {cards.map(c => (
          <div key={c.label} className="bg-slate-900 rounded-2xl p-5 border border-slate-800">
            <c.icon className={`${c.color} mb-3`} size={22} />
            <p className="text-3xl font-bold text-white">{c.value}</p>
            <p className="text-slate-400 text-sm mt-1">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="text-slate-500 text-sm">
        Usa la barra lateral para gestionar clínicas y médicos.
      </div>
    </div>
  );
}
